import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vergelijknl.webp';
import screenshot_target from '../../../images/letterfunnel/jorisverwater.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Joris Verwater"
      firstname="Joris"
      companyname="Vergelijk.nl"
      competition="Beslist.nl en Kieskeurig.nl"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/jorisverwater.js